import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingSection() {
  const hotArticles = articles
    .filter((a) => a.isHot)
    .sort((a, b) => b.readCount - a.readCount)
    .slice(0, 6);

  const formatCount = (count: number): string => {
    if (count >= 10000) return (count / 10000).toFixed(1) + '万';
    return count.toString();
  };

  return (
    <section className="py-8 md:py-10">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-fire-line text-white text-base"></i>
            </div>
            <h2 className="text-lg md:text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              今日热门
            </h2>
          </div>
          <Link
            to="/category/yule-bagua"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {hotArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex items-start gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 no-underline"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 font-bold text-sm flex-shrink-0">
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug mb-1.5">
                  {article.title}
                </h4>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="px-1.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700 font-medium">
                    {article.categoryName}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatCount(article.readCount)}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}